import { createClient, reservoirChains } from "@reservoir0x/reservoir-sdk";
import { getChain } from "@talentir/shared/helpers";
import { useState } from "react";

export function useReservoirkitClient() {
    const reservoirChain = (() => {
        if (getChain().name === "Arbitrum One") {
            return reservoirChains.arbitrum;
        }
        if (getChain().name === "Sepolia") {
            return reservoirChains.sepolia;
        }
        if (getChain().name === "Base") {
            return reservoirChains.base;
        }
        if (getChain().name === "Base Sepolia") {
            return reservoirChains.baseSepolia;
        }

        throw new Error("Unsupported chain");
    })();

    const [client] = useState(
        createClient({
            apiKey: "32536bf0-7359-5d87-aa79-8982eb14cbd8",
            chains: [
                {
                    ...reservoirChain,
                    active: true,
                },
            ],
        }),
    );

    return client;
}
